/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

export class WebStorage implements Storage {
  /**
   * Returns the number of key/value pairs currently present in the list associated with the
   * object.
   */
  public readonly length: number;

  constructor(private providers: Storage[]) {
    this.length = 0;
  }

  /**
   * Empties the list associated with the object of all key/value pairs, if there are any.
   */
  public clear(): void {
    this.providers.forEach((provider) => provider.clear());

    return;
  }

  /**
   * value = storage[key]
   */
  public getItem(key: string): string | null {
    for (const provider of this.providers) {
      const val = provider.getItem(key);
      if (val != null) {
        return val;
      }
    }

    return null;
  }

  /**
   * Returns the name of the nth key in the list, or null if n is greater
   * than or equal to the number of key/value pairs in the object.
   */
  public key(index: number): string | null {
    for (const provider of this.providers) {
      const val = provider.key(index);
      if (val != null) {
        return val;
      }
    }

    return null;
  }

  /**
   * delete storage[key]
   */
  public removeItem(key: string): void {
    this.providers.forEach((provider) => provider.removeItem(key));

    return;
  }

  /**
   * storage[key] = value
   */
  public setItem(key: string, value: string): void {
    this.providers.forEach((provider) => provider.setItem(key, value));

    return;
  }
}
